import { IProductWarranty } from 'modules/inventory/product/interfaces/IProductWarranty';

export const normalizeWarranty = (value?: IProductWarranty): IProductWarranty => {
  if (!value?.enabled) return { enabled: false };
  return {
    enabled: true,
    time: value.time,
    unit: value.unit || 'days',
    ...(value.description ? { description: value.description } : {}),
  };
};
